module.exports = {"pathContext":{"slug":"/en/terms_conditions/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-terms-conditions.json
// module id = 1182
// module chunks = 167545422930614